import {
  COMPONENT_STATE_ARGS,
  INPUT_MENU_ARGS,
  MENU_ARGS,
  Metadata,
  pick,
} from '../../../../../utils/spds/metadata';
import { fn, hash } from '@ember/helper';
import ListItem from './item.gjs';
import Menu from '../../../core/menu/base.gjs';
import Super from '../../../core/menu/parent.gjs';

const METADATA = Metadata.define({
  description: 'Menu container for dropdown list options',
  extends: [
    pick(MENU_ARGS, ['anchorElement']),
    pick(COMPONENT_STATE_ARGS, [{ name: 'open', required: true }]),
    pick(INPUT_MENU_ARGS, ['noResultsText', 'searchable', 'searchPlaceholder', 'searchThreshold']),
  ],
  name: 'Dropdown List Menu',
});

export default class SpdsInputDropdownListMenu extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  baseClass = 'spds-input-dropdown-list-menu';

  <template>
    <Menu
      @anchorElement={{@anchorElement}}
      @animated={{true}}
      @id={{this.id}}
      @noResultsText={{@noResultsText}}
      @open={{@open}}
      @searchable={{@searchable}}
      @searchPlaceholder={{@searchPlaceholder}}
      @searchThreshold={{@searchThreshold}}
      class={{this.classes}}
      data-test-spds-input-dropdown-list-menu
      {{this.validateArguments}}
      ...attributes
    >
      {{yield
        (hash
          item=(component
            ListItem
            onClick=@onSelect
            registerComponent=(fn this.registerItem false)
            retainSelection=@retainSelection
            unregisterComponent=this.unregisterItem
          )
        )
      }}
    </Menu>
  </template>
}

export const DROPDOWN_LIST_MENU_METADATA = SpdsInputDropdownListMenu.metadata;
